import React from 'react'

import LandingFooterContainer from './LandingFooterStyles'

const LandingFooter = () => {
  return (
    <LandingFooterContainer className="footer-container">
      <span>
        &copy;1998-{new Date().getFullYear()} CMH Services, Inc. All rights
        reserved.
      </span>
      <span className="hide-very-small"> | </span>
      <span className="footer-links">
        <a href="https://www.claytonhomes.com/legal/">Legal</a>
        <span> | </span>
        <a href="https://www.claytonhomes.com/privacy/">Privacy</a>
        <span> | </span>
        <a
          href="#"
          onClick={e => {
            e.preventDefault()
            window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
          }}
        >
          Do Not Sell or Share My Personal Information
        </a>
      </span>
    </LandingFooterContainer>
  )
}

export default LandingFooter



// WEBPACK FOOTER //
// ./src/components/LandingFooter/LandingFooter.js